/* eslint 'array-callback-return': 'off','no-array-constructor': 'off','no-redeclare': 'off','no-useless-escape' : 'off', eqeqeq: 'off', 'no-loop-func': 'off' ,'react/no-direct-mutation-state': 'off' */
import React, { Component } from 'react';
import { connect } from "react-redux";
import { ScheduleComponent, Agenda, Day, Week, WorkWeek, Month, Inject } from '@syncfusion/ej2-react-schedule';
import { Col, Button, FormGroup, Label, Form, Modal } from 'reactstrap';
import { applyCategoryColor } from './datasource';
import '../../../../../Assets/EnsembleStyles/ej2_material.css';
import '../../../../../Assets/EnsembleStyles/ScheduleCalendar.css'
import { GetAllRequests, DeleteTenantRequests, SaveRequest, UpdateRequest, GetSelectedRequest, GetTimeZoneForZone, GetAllPastRequests, GetSelectedPastRequest } from '../../../../../action/requestAction';
import { GetAllTenantList, GetZonesListforTenant, GetCalculateCost } from '../../../../../action/tenantAction';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { RecurrenceEditorComponent } from '@syncfusion/ej2-react-schedule';
import { DateTimePickerComponent } from '@syncfusion/ej2-react-calendars';
import {createElement, isNullOrUndefined} from '@syncfusion/ej2-base';
import SearchInput, { createFilter } from 'react-search-input';
import { setAmplitudeEvent } from 'amplitude/amplitude';
import 'babel-polyfill';
import moment from 'moment';
import APIutil from 'api/APIutils';
import * as url from 'api/url';
import randomColor from 'randomcolor';

const KEYS_TO_FILTERS = ['tenantName'];
let previous_date = localStorage.setItem("increment", 0);   //eslint-disable-line
let lUserCanEdit = true;
let filter_list; 
let filtered_data_update = new Array();

class RequestsCalendar extends Component {

    async componentWillMount() {
        const zone_timezones = this.props.GetTimeZoneForZone();
        await Promise.all([zone_timezones]);
    }


    async componentDidMount() {
        const Tenants = this.props.GetAllRequests();
        const Requests = this.props.GetAllTenantList(); 
        await Promise.all([Tenants, Requests]);
        this.manageEventListener("add");
    }

    componentWillReceiveProps(nextProps) {
        if (this.props != nextProps) {
            this.setState({ timezone_state: nextProps.Zone_TimeZone_Response });
            if(nextProps.PastRequest !== undefined && nextProps.RequestList_Response !== undefined){
                const RequestList = nextProps.RequestList_Response.map(activerequest => ({...activerequest,IsPastRequest:false}));
                const PastRequestList = nextProps.PastRequest.map(pastrequest => ({...pastrequest,IsPastRequest:true}));
                this.setState({ requestList_in_state: [...RequestList, ...PastRequestList]});
            }
            this.setState({ tenantList_in_state: nextProps.Tenant_List_Response.TenantNameList });
            if (nextProps.Tenant_ZoneList_Response !== undefined) {
                this.setState({ zonesList_in_state: nextProps.Tenant_ZoneList_Response });
            }
            this.setState({ get_individual_request_data_in_state: nextProps.Request_Selected_Response });
        }
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleButtonClick);
        this.manageEventListener();
    }

    constructor(props) {
        super(props);
        super(...arguments);
        this.state = {
            requestList_in_state: null,
            tenantList_in_state: null,
            zonesList_in_state: null,
            get_individual_request_data_in_state: null,
            filter_checkboxes_selected: [],
            RecurDays_in_state: false,
            Number_of_RecurDays_in_state: null,
            isSingleRequest: "repeat_row",
            searchTerm: '',
            coloring: 'red',
            request_type: 'red',
            modal: false,
            edit_request_ID: null,
            timezone_state: null,
            request_status: '',
            request_created:'',
        }

        this.tenant_dropdown_fields = { text: 'tenantName', value: 'tenantId' };
        this.zones_dropdown_fields = { text: 'zoneName', value: 'zoneId' };

        this.filterTenants = this.filterTenants.bind(this);
        this.searchUpdated = this.searchUpdated.bind(this);
        this.editorTemplate = this.editorTemplate.bind(this);
        this.handleRadio = this.handleRadio.bind(this);
        this.LoadTenantZones = this.LoadTenantZones.bind(this);
        this.calculateCost = this.calculateCost.bind(this);
        this.toggle = this.toggle.bind(this);
        this.SaveData = this.SaveData.bind(this);
        this.DeleteRequest = this.DeleteRequest.bind(this);
        this.getZoneTimeZoneDate = this.getZoneTimeZoneDate.bind(this);
        this.handleButtonClick = this.handleButtonClick.bind(this);
        this.manageEventListener = this.manageEventListener.bind(this);
        this.addBrowserOffset = this.addBrowserOffset.bind(this);
    }

    handleButtonClick(event) {
        event.preventDefault();
        event.stopPropagation();
    }

    toggle() {
        // e.preventDefault();
        this.setState({
            modal: !this.state.modal,
        });
    }

    // Tool Tip System 

    template(props) {
        return (<div className="tooltip-wrap">
            <div className="city">{props.tenantName}</div>
            <div className="content-area"><div className="event-name">{props.zoneName},{props.buildingName}</div>
                <div className="time">From&nbsp;:&nbsp;{props.startDateTime.toLocaleString()}</div>
                <div className="time">To&nbsp;:&nbsp;{props.stopDateTime.toLocaleString()}</div>
                {(props.City !== null && props.City !== undefined) ? <div className="city">{props.tenantName}</div> : ''}
            </div></div>);
    }

    onToolTipChange(args) {
        if (args.checked) {
            this.scheduleObj.eventSettings.enableTooltip = true;
        }
        else {
            this.scheduleObj.eventSettings.enableTooltip = false;
        }
        this.scheduleObj.dataBind();
    }

    onToolTipTemplateChange(args) {
        if (args.checked) {
            this.scheduleObj.eventSettings.tooltipTemplate = this.template.bind(this);
        }
        else {
            this.scheduleObj.eventSettings.tooltipTemplate = null;
        }
        this.scheduleObj.dataBind();
    }




    // End of Tool Tip System 

     //This function is used to get the Browser zone offset and actual datetime
    addBrowserOffset(datetimeStr) {
    const datetimeWithoutOffset = datetimeStr.substring(0, 19); // Remove offset

    const date = new Date();
    const offsetMinutes = date.getTimezoneOffset(); // DO NOT negate

    // getTimezoneOffset returns minutes behind UTC, so reverse the sign for ISO
    const sign = offsetMinutes <= 0 ? "+" : "-";
    const absOffset = Math.abs(offsetMinutes);
    const pad = (n) => String(Math.floor(Math.abs(n))).padStart(2, "0");
    const hours = pad(absOffset / 60);
    const minutes = pad(absOffset % 60);

    console.log("addBrowserOffset", `${datetimeWithoutOffset}${sign}${hours}:${minutes}`);
    return `${datetimeWithoutOffset}${sign}${hours}:${minutes}`;
    }



    //Filter System for Schedule
    filterTenants() {           //Filter System for Schedule
        var Data = [];
        var checkboxes = document.getElementsByClassName('tenant_records');
        for (var i = 0; i < checkboxes.length; i++) {
            if (checkboxes[i].checked === true) {
                //eslint-disable-next-line
                var tenants_to_be_filtered = {
                    "tenantId": checkboxes[i].id
                }
                Data.push(checkboxes[i].id);
            }
        }
        this.setState({ filter_checkboxes_selected: Data })
    }


    // End of Filter System for Schedule

    manageEventListener(actionKey) {
        const saveButton =  document.getElementById('request_save_btn');
        const cancelButton =  document.getElementById('request_cancel_btn');
        const deleteButton =  document.getElementById('request_delete_btn');
        const calculateButton =  document.getElementById('Calculate_cost_btn');
        const singleRequest = document.getElementById('reqtype');
        const repeatRequest = document.getElementById('repeat_reqtype');
        if(actionKey === "add") {
            saveButton && saveButton.addEventListener('click', () => this.SaveData());
            cancelButton && cancelButton.addEventListener('click', () => this.CancelPopup("close_popup"));
            deleteButton && deleteButton.addEventListener('click', () => this.DeleteRequest());
            calculateButton && calculateButton.addEventListener('click', () => this.calculateCost());
            singleRequest && singleRequest.addEventListener('change',() => this.handleRadio());
            repeatRequest && repeatRequest.addEventListener('change',() => this.handleRadio());
        } else {
            saveButton && saveButton.removeEventListener('click', () => this.SaveData());
            cancelButton && cancelButton.removeEventListener('click', () => this.CancelPopup("close_popup"));
            deleteButton && deleteButton.removeEventListener('click', () => this.DeleteRequest());
            calculateButton && calculateButton.removeEventListener('click', () => this.calculateCost());
            singleRequest && singleRequest.removeEventListener('change',() => this.handleRadio());
            repeatRequest && repeatRequest.removeEventListener('change',() => this.handleRadio());
        }
    }

    //On Popup Open

    async  onPopupOpen(args) {
        document.getElementsByClassName('e-btn e-today e-flat e-primary e-css')[0].addEventListener('click', this.handleButtonClick);
        // this.manageEventListener("add");

        if (args.type === "Editor") {
            if (!lUserCanEdit) {
                args.cancel = true
            }

            document.getElementById('reqtype').checked = true;
            document.getElementById('repeat_reqtype').checked = false;
            document.getElementById('request_save_btn').style.visibility = args.data.IsPastRequest ? 'hidden' : 'visible';
            document.getElementById('request_delete_btn').style.visibility = args.data.IsPastRequest ? 'hidden' : 'visible';
            document.getElementById('requestComment').disabled = args.data.IsPastRequest;


            let default_recur_day = ["SU", "MO", "TU", "WE", "TH", "FR", "SA",]
            this.recObject.setRecurrenceRule("FREQ=WEEKLY;BYDAY=" + default_recur_day[new Date(this.startTimeObj.value).getDay()] + ";INTERVAL=1;");   // Reset the recuurence editor to default day
            var recurrence_default_rule = "FREQ=WEEKLY;BYDAY=" + default_recur_day[new Date(this.startTimeObj.value).getDay()] + ";INTERVAL=1;";

            this.setState({ RecurDays_in_state: false, Number_of_RecurDays_in_state: recurrence_default_rule });
            this.recCompleteObject.className = "repeat_row";

            document.getElementById('cost_modal_error').innerHTML = ""
            if (args.type === 'Editor') {
                let heading = args.element.querySelector('.e-title-text');                                                          // Changing  the header names in the pop up to Add and Edit request
                (args.data.IsPastRequest) ? heading.innerHTML = "Past Request" : (heading.innerHTML === "New Event") ? heading.innerHTML = "New Request" : heading.innerHTML = "Edit Request"

                this.tenantObj.index = 0;
                
                /* Removing the dynamically created rows from DOM */
                if (!isNullOrUndefined(document.getElementById("status"))) {
                    var delStatus = document.getElementById("status");
                    delStatus.parentNode.removeChild(delStatus);
                    var delSpace = document.getElementById("spaceAfterStatus");
                    delSpace.parentNode.removeChild(delSpace);
                }
                if (!isNullOrUndefined(document.getElementById("createdBy"))) {
                    var delCreatedby = document.getElementById("createdBy");
                    delCreatedby.parentNode.removeChild(delCreatedby);
                    var delSpace = document.getElementById("spaceBeforeCreated");
                    delSpace.parentNode.removeChild(delSpace);
                }
 
                if (args.data.hasOwnProperty('tenantName')) {
                    var get_individual_request_data = (args.data.IsPastRequest) ? this.props.GetSelectedPastRequest(args.data.requestId): this.props.GetSelectedRequest(args.data.requestId);
                    await Promise.all([get_individual_request_data]);
                    this.tenantObj.enabled = false;
                    this.zoneObj.enabled = false;
                    let data_from_state = null;
                    data_from_state = this.state.get_individual_request_data_in_state;

                    this.startTimeObj.enabled = (data_from_state.status == 1 || data_from_state.status == 4 || args.data.IsPastRequest ? false : true);
                    this.endTimeObj.enabled = (data_from_state.status == 4 || args.data.IsPastRequest ? false : true);
                    this.requestDiv.style.visibility = (data_from_state.status == 1 || data_from_state.status == 4 || args.data.IsPastRequest ? 'hidden' : 'visible');

                    this.tenantObj.value = args.data.tenantId;
                    this.tenantObj.text = args.data.tenantName;

                    var zonObj = [{
                        zoneId: data_from_state.zoneId, zoneName: data_from_state.zoneName
                    }];
                    this.zoneObj.dataSource = zonObj;
                    this.zoneObj.index = 0;
                    this.zoneObj.dataBind();
                    this.commentObj.value = data_from_state.requestComment;
                    var min_value = this.roundDateTime();

                    this.startTimeObj.min = min_value;
                    this.endTimeObj.min = min_value;
                    this.setState({ edit_request_ID: data_from_state.changeRequestId });

                    this.state.request_status = (args.data.IsPastRequest) ? "Past Request" : (data_from_state.status === 0) ? "Future Request" : (data_from_state.status === 1) ? "In Progress" : "Redundant Request";
                    this.state.request_created = data_from_state.createdBy + " | " + new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'short', day: 'numeric' }).format(new Date(data_from_state.createdDateTime));

                    if (this.startTimeObj.value <= new Date()) {
                        this.startTimeObj.enabled = false;
                        this.requestDiv.style.visibility = 'hidden';
                    }
                     /* Creating dynamic rows for Edit Request */
                     if(heading.innerHTML === "Edit Request" || heading.innerHTML === "Past Request"){
                        let tableElement = args.element.querySelector('#custom-event-editor');
                        
                        /* Status row in Edit Request */
                        let row = createElement('tr',{id:"status"});
                        let space = createElement('tr',{id:"spaceAfterStatus",attrs:{height: '10px'}});
                        tableElement.firstChild.insertBefore(row, tableElement.firstChild.firstChild);
                        tableElement.firstChild.insertBefore(space, row.nextSibling);
                        let data1 = createElement('td',{className: "e-textlabel", innerHTML: "Status"});
                        let data2 = createElement('td',{attrs:{colSpan: '4'}, innerHTML: this.state.request_status});
                        row.appendChild(data1);
                        row.appendChild(data2);
                    
                        /* CraetedBy row in Edit Request*/
                        let row2 = createElement('tr',{id:"createdBy", style:"margin-top:1px"});
                        let space2 = createElement('tr',{id:"spaceBeforeCreated",attrs:{height: '10px'}});
                        tableElement.firstChild.insertBefore(row2, tableElement.firstChild.lastChild.nextSibling);
                        tableElement.firstChild.insertBefore(space2, row2);
                        let data3 = createElement('td',{className: "e-textlabel", innerHTML: "Created"});
                        let data4 = createElement('td',{attrs:{colspan: '4'}, innerHTML: this.state.request_created});
                        row2.appendChild(data3);
                        row2.appendChild(data4);    
                    }                  
                }
                else {
                    var lTenantID = this.tenantObj.value === null ? this.tenantObj.props?.dataSource?.[0]?.tenantId : this.tenantObj.value;
                    this.props.GetZonesListforTenant(lTenantID).then(response => {
                        this.zoneObj.dataSource = response;
                        this.zoneObj.index = 0;
                        this.zoneObj.dataBind();
                    });


                    this.tenantObj.enabled = true;
                    this.zoneObj.enabled = true;
                    this.startTimeObj.enabled = true;
                    this.endTimeObj.enabled = true;
                    this.requestDiv.style.visibility = 'visible';
                    this.commentObj.value = '';

                    var min_value = this.roundDateTime();
                    this.startTimeObj.min = min_value;
                    this.endTimeObj.min = min_value;

                    // var check_same_date = new Date(this.startTimeObj.value).getDate();
                    // var min_date = new Date(min_value).getDate();

                    // if (check_same_date === min_date) {
                    //     this.startTimeObj.value = min_value;
                    //     this.endTimeObj.value = min_value;
                    // }
                } 
            }
        }

    }

    //End of Popup open



    // Loading places/zones list based on tenant id.
    LoadTenantZones(args) {
        if (args.e !== undefined && args.e !== null) {
            this.props.GetZonesListforTenant(this.tenantObj.value).then(response => {
                this.zoneObj.enabled = true;
                this.zoneObj.index = 0;
                this.zoneObj.dataSource = response;
                this.zoneObj.dataBind();
            });
        }
    }

    // Loading places/zones list based on tenant id.

    SaveData() {

        var sst = this.startTimeObj.value;
        var est = this.endTimeObj.value;
        var tenantID = this.tenantObj.value;
        var zoneID = this.zoneObj.value;
        var requestComment = this.commentObj.value;
        var min_value = this.roundDateTime();

        if (tenantID === null || tenantID === undefined || tenantID === "") {
            document.getElementById('cost_modal_error').innerHTML = 'Error: Tenants field cannot be empty!';
        }
        else if (zoneID === null || zoneID === undefined || zoneID === "") {
            document.getElementById('cost_modal_error').innerHTML = 'Error: Zone cannot be empty!';
        }
        else if (this.startTimeObj.value === "" || this.startTimeObj.value === null || this.startTimeObj.value === undefined) {
            document.getElementById('cost_modal_error').innerHTML = 'Error: Start time field cannot be empty!';
        }
        else if (this.endTimeObj.value === "" || this.endTimeObj.value === null || this.endTimeObj.value === undefined) {
            document.getElementById('cost_modal_error').innerHTML = 'Error: End time field cannot be empty!';
        }
        else if (+sst == +est) {
            document.getElementById('cost_modal_error').innerHTML = 'Error: From time and To Time cannot be equal!';
        }
        else if (sst > est) {
            document.getElementById('cost_modal_error').innerHTML = 'Error: Start date cannot be gretaer than End date!';
        }
        else if (this.startTimeObj.enabled === false && this.endTimeObj.value < min_value) {
            document.getElementById('cost_modal_error').innerHTML = 'Error: End date time cannot be past date time';
        }
        else if (this.startTimeObj.enabled === true && this.startTimeObj.value < min_value) {
            document.getElementById('cost_modal_error').innerHTML = 'Error: Start date time cannot be past date time';
        }


        else {
            var st = this.startTimeObj.value;
            var et = this.endTimeObj.value;

            var startDateTime = st.getFullYear() + "/" + (st.getMonth() + 1) + "/" + st.getDate() + " " + st.getHours() + ":" + st.getMinutes() + ":00";
            var stopDateTime = et.getFullYear() + "/" + (et.getMonth() + 1) + "/" + et.getDate() + " " + et.getHours() + ":" + et.getMinutes() + ":00";

            let twoDigitMonth = (et.getMonth() + 1).toString().length > 1 ? (et.getMonth() + 1) : "0" + (et.getMonth() + 1).toString();
            let twoDigitDay = et.getDate().toString().length > 1 ? et.getDate() : "0" + et.getDate().toString();
            var recurtime = twoDigitDay + "/" + twoDigitMonth + "/" + et.getFullYear();


            var Request = {
                "StartDateTime": startDateTime,
                "EndDateTime": stopDateTime,
                "TenantId": tenantID,
                "ZoneId": zoneID,
                "Comment": requestComment,
            }
            // Returns an array of dates between the two dates
            const eventProperties = { "Selected UI option": "Calendar" }
            //Saving  Edit Request

            if (this.state.RecurDays_in_state) {                                                   // Checking whether repeating option has selected, if yes adding "IsRepeat" ,"RecurDays","RecurTime" key values to request object


                var Selected_Date_range_for_comparision = [];
                var currentDate = st;
                var addDays = function (days) {
                    var date = new Date(this.valueOf());
                    date.setDate(date.getDate() + days);
                    return date;
                };
                while (currentDate <= et) {
                    Selected_Date_range_for_comparision.push(currentDate.getDay().toString());
                    currentDate = addDays.call(currentDate, 1);
                }

                let recuringDays = [];
                let recur_days = ["SU", "MO", "TU", "WE", "TH", "FR", "SA",]
                if (this.state.Number_of_RecurDays_in_state !== null) {
                    var recuring_days_from_calendar = this.state.Number_of_RecurDays_in_state.substring(                    //splitting only recur days string from calendar     Ex : FREQ=WEEKLY;BYDAY=SU,MO,TU,WE,SA;INTERVAL=1; to    ["SU", "MO", "TU", "WE", "SA"]
                        this.state.Number_of_RecurDays_in_state.lastIndexOf("BYDAY=") + 6,
                        this.state.Number_of_RecurDays_in_state.lastIndexOf(";INTERVAL")
                    ).split(",");

                    recur_days.forEach((e1, index) => recuring_days_from_calendar.forEach((e2) => {                // Comparing arrays of static recur_days to dynamically obtained recurring days from calendar to get index values. Ex:   ["SU", "MO", "TU", "WE", "SA"]  to   
                        if (e1 === e2) { recuringDays.push(index.toString()); }                                           //  ["0", "1", "2", "3", "6"]
                    }))
                }

                var arrayContainsArray = function (superset, subset) {
                    return subset.every(function (value) {
                        return (superset.indexOf(value) >= 0);
                    });
                }

                var days_falling_in_range = arrayContainsArray(Selected_Date_range_for_comparision, recuringDays)
                if (recuringDays.length <= 0) days_falling_in_range = false;

                if (days_falling_in_range) {
                    document.getElementById('cost_modal_error').innerHTML = '';
                    Request["IsRepeat"] = true;
                    Request["RecurDays"] = recuringDays;
                    Request["RecurTime"] = recurtime;
                }
                else {
                    document.getElementById('cost_modal_error').innerHTML = 'Error: Selected days does not fall in range!';
                    return;
                }
                eventProperties["Repeating Request"] = true;
            }
            else {
                eventProperties["Repeating Request"] = false;
                Request["isRepeat"] = false;
            }


            if (this.state.edit_request_ID === null) {
                Request["RequestId"] = 0;
                setAmplitudeEvent("New After Hours Request", eventProperties);
                this.props.SaveRequest(Request);
            }
            else if (this.state.edit_request_ID !== null) {
                Request["RequestId"] = this.state.edit_request_ID;
                this.props.UpdateRequest(Request);
                setAmplitudeEvent("Edit After Hours Request", { "Selected UI option": "Calendar" });
            }
            this.setState({ edit_request_ID: null });

            this.CancelPopup("Save_Cancel");
            //this.refreshEvents()
        }

    }


    CancelPopup(cancel_type) {
        localStorage.setItem("navigated_date", JSON.stringify(this.startTimeObj.value));
        localStorage.setItem("cancel_type", cancel_type);
        this.setState({ RecurDays_in_state: false, Number_of_RecurDays_in_state: null });
        this.setState({ edit_request_ID: null });
        var test = document.getElementsByClassName('e-schedule-dialog-container');
        test[0].style.display = "none";
        document.getElementById("_dialog_wrapper").className = "e-dialog e-schedule-dialog e-dlg-modal e-control e-popup e-popup-close";
        this.manageEventListener();
    }

    DeleteRequest() {
        if (this.state.edit_request_ID) {
            let data = [{ "requestId": this.state.edit_request_ID }]
            this.props.DeleteTenantRequests(data);
            this.setState({ edit_request_ID: null });
            this.CancelPopup("Delete_Cancel");
        }
    }

    // Action Complete
    onActionComplete(args) {
        let list = [];
        filtered_data_update = new Array();
        if (args.requestType === "toolBarItemRendered") {
            this.scheduleObj.element.querySelectorAll('.e-schedule-toolbar .e-date-range')[0].click();
            let st = new Date();
            this.scheduleObj.element.querySelectorAll('.e-calendar')[0].ej2_instances[0].min =  new Date(st.getFullYear() -1  + "/" + (st.getMonth() + 1) + "/01" );
            this.scheduleObj.element.querySelectorAll('.e-schedule-toolbar .e-date-range')[0].click();
        }
        // if (args.requestType === "eventCreated" || args.requestType === "eventChanged") {
        //     this.refreshEvents();
        // }
        if(args.requestType === "viewNavigate" || (args.requestType === "dateNavigate")){
            var currentViewDates = this.scheduleObj.getCurrentViewDates(); 
            var startDate = moment(new Date(currentViewDates[0].setHours(0,0,0,0))).format('YYYY-MM-DDTHH:mm:ss'); 
            var endDate = moment(new Date(currentViewDates[currentViewDates.length - 1].setHours(23,59,59,59))).format('YYYY-MM-DDTHH:mm:ss');    
                var pastRequestDate = {
                "FromDate": startDate,
                "ToDate": endDate,
            }
            APIutil.postData(url.get_PastRequest,pastRequestDate).then(response => {
                if(response.data !== null && response.data !== undefined){
                    let updated_data = new Array();
                    var colorObject = new Array();
                    var get_sessionStored_ColorObj = JSON.parse(localStorage.getItem("uploaded_colorObj")); 
                    let unique_tenantID_Array = response.data !== "" ? [...new Set(response.data.map(item => item.tenantId))] : []; 
                    for (var j = 0; j < unique_tenantID_Array.length; j++) {
                        var unique_color_for_tenant = randomColor.randomColor({ luminosity: 'bright' });   // generating random color 
                        for (var i = 0; i < response.data.length; i++) {
                            if (response.data[i].tenantId === unique_tenantID_Array[j]) {
                                var o = Object.assign({}, response.data[i]);
                                var  unique_color_from_session = null;
                            if(get_sessionStored_ColorObj !==null){                     //Comparing the session object for colors, if available assigning the color 
                                 get_sessionStored_ColorObj.filter(function(e) {
                                    if(e.tenantid ===response.data[i].tenantId ){
                                        unique_color_from_session = e.CategoryColor;
                                    }
                                });
                            }
                            (unique_color_from_session !== null) ?   o.CategoryColor = unique_color_from_session : o.CategoryColor = unique_color_for_tenant;   //assigning the categor color from 
                                var sessionObj = {                //Storing the categorycolor alomng with tenantID  in Session as objects of array
                                    tenantid: response.data[i].tenantId,
                                    CategoryColor : o.CategoryColor,
                                  };
                                colorObject.push(sessionObj);
                                localStorage.setItem("uploaded_colorObj",JSON.stringify(colorObject));     //stringifying the object  to set item in session storage
                                updated_data.push(o);
                            }
                        }
                    }
                    const RequestList = this.props.RequestList_Response.map(activerequest => ({...activerequest,IsPastRequest:false}));
                    const PastRequestList = updated_data.map(pastrequest => ({...pastrequest,IsPastRequest:true}));
                    list = [...RequestList,...PastRequestList]
                //we are updating the list with the past request data and active request data by adding the browser offset to the start and end times
                    list =  list.map(event => ({...event, startDateTime: this.addBrowserOffset(event.startDateTime), 
                                                    stopDateTime: this.addBrowserOffset(event.stopDateTime)
                              }));                              
                    let { filter_checkboxes_selected } = this.state;
                    let uniques_tenants_for_filter, FilteredData;
                    lUserCanEdit = this.props.UserCanEdit;
                    lUserCanEdit = lUserCanEdit !== undefined && lUserCanEdit !== null && lUserCanEdit ? true : false;

                    if (list !== null) {

                        if (filter_checkboxes_selected.length > 0) {               // validating if any checkboxes are selected 
                            list.filter(function (el) {                     // if selected filtering selected checkboxes and displaying selected tenant records on calendar
                                if (filter_checkboxes_selected.indexOf(el.tenantId.toString()) !== -1) {
                                    filtered_data_update.push(el);
                                }
                            });
                        }
                        else {
                            filtered_data_update = list;
                        }
                        this.scheduleObj.eventSettings.dataSource = filtered_data_update;
                        uniques_tenants_for_filter = list.reduce((unique, k) => {         // identifying or sorting unique tenant records to display in filter system i.e., on checkboxes list
                            if (!unique.some(obj => obj.tenantId === k.tenantId)) {
                                unique.push(k);
                            }
                            return unique;
                        }, []);

                        if (uniques_tenants_for_filter.length !== 0) {

                            FilteredData = uniques_tenants_for_filter.filter(createFilter(this.state.searchTerm, KEYS_TO_FILTERS));
                            filter_list = FilteredData.map(el => (

                                <label className="chckbx_container" key={el.tenantId}>{el.tenantName}
                                    <input type="checkbox" id={el.tenantId} className="tenant_records" onClick={this.filterTenants} />
                                    <span className="checkmark" style={{ 'backgroundColor': el.CategoryColor }}></span>
                                </label>
                            ));
                        }
                    }
                }
            })
        }
    }
    // Action Complete

    handleRadio(){
        (!this.reqType.checked) ? this.recCompleteObject.className = "repeat_row" : this.recCompleteObject.className = "repeat_row_display";   // Hiding and Displaying recuring days based on the checked radio button in the request form.
        (!this.reqType.checked) ? this.setState({ RecurDays_in_state: null }) : this.setState({ RecurDays_in_state: this.reqType.checked });

        if (!this.reqType.checked) {
            let default_recur_day = ["SU", "MO", "TU", "WE", "TH", "FR", "SA",]
            this.recObject.setRecurrenceRule("FREQ=WEEKLY;BYDAY=" + default_recur_day[new Date().getDay()] + ";INTERVAL=1;");   // Reset the recuurence editor to default day
        }
    }


    cellDoubleClick(args) {
        if (args.name == "cellDoubleClick") {
            let { Zone_TimeZone_Response } = this.props
            if (Zone_TimeZone_Response === null) {
                if (args.endTime < new Date()) {
                    args.cancel = true;
                }
            }
            else {
                if (Zone_TimeZone_Response.BaseUtcOffset !== null || Zone_TimeZone_Response.BaseUtcOffset !== undefined) {
                    //ar BaseUtcOffset_timezone = Zone_TimeZone_Response.BaseUtcOffset;
                    // var BaseUtcOffset_timezone = "05:30:00";
                    //var split_data = BaseUtcOffset_timezone.split(/[\:]/);
                    //var offset = split_data[0] + '.' + split_data[1];
                    var d = new Date();
                    //var utc = d.getTime() + (d.getTimezoneOffset() * 60000);

                    //var nd = new Date(utc + (3600000 * offset));
                    if (args.endTime < d) {
                        args.cancel = true;
                    }
                }
                else {
                    if (args.endTime < new Date()) {
                        args.cancel = true;
                    }
                }
            }
        }
    }

    onRenderCell(args) {
        document.getElementsByClassName('e-btn e-today e-flat e-primary e-css')[0].addEventListener('click', this.handleButtonClick);
        let { Zone_TimeZone_Response } = this.props

        if (Zone_TimeZone_Response === null) {
            if (args.date < new Date(new Date().setHours(0, 0, 0, 0))) {
                args.element.classList.add('e-disableCell');
            }
        }
        else {
            if (Zone_TimeZone_Response.BaseUtcOffset !== null || Zone_TimeZone_Response.BaseUtcOffset !== undefined) {
                var BaseUtcOffset_timezone = Zone_TimeZone_Response.BaseUtcOffset;
                // var BaseUtcOffset_timezone = "05:30:00";
                var split_data = BaseUtcOffset_timezone.split(/[\:]/);
                var offset = split_data[0] + '.' + split_data[1];
                var d = new Date();
                var utc = d.getTime() + (d.getTimezoneOffset() * 60000);
                var nd = new Date(utc + (3600000 * offset));

                if (args.elementType === "monthCells") {
                    if (args.date < new Date(nd.setHours(0, 0, 0, 0))) {
                        args.element.classList.add('e-disableCell');
                    }
                }
                else {
                    if (args.date < d) {
                        args.element.classList.add('e-disableCell');
                    }
                }
            }
            else {
                if (args.date < new Date(new Date().setHours(0, 0, 0, 0))) {
                    args.element.classList.add('e-disableCell');
                }
            }
        }

    }

    getZoneTimeZoneDate() {

        let { Zone_TimeZone_Response } = this.props;
        let previous_date = localStorage.getItem("navigated_date");
        let i = localStorage.getItem("increment");
        (previous_date === "null") ? localStorage.setItem("increment", 0) : localStorage.setItem("increment", parseInt(i) + 1);

        if (previous_date !== "null" && localStorage.getItem("increment") === "1" && localStorage.getItem("cancel_type") === "close_popup") {
            let scrolled_date = JSON.parse(previous_date);
            localStorage.setItem("navigated_date", null);
            localStorage.setItem("increment", 0);
            localStorage.setItem("cancel_type", null);
            return new Date(scrolled_date);
        }
        else if (previous_date !== "null" && localStorage.getItem("increment") === "2" && localStorage.getItem("cancel_type") === "Delete_Cancel") {
            let scrolled_date = JSON.parse(previous_date);
            localStorage.setItem("navigated_date", null);
            localStorage.setItem("increment", null);
            return new Date(scrolled_date);
        }
        else if (previous_date !== "null" && localStorage.getItem("increment") === "3") {
            let scrolled_date = JSON.parse(previous_date);
            localStorage.setItem("navigated_date", null);
            localStorage.setItem("increment", null);
            return new Date(scrolled_date);
        }
        else if (Zone_TimeZone_Response === null) {
            return new Date();
        }
        else {
            if (Zone_TimeZone_Response.BaseUtcOffset !== null || Zone_TimeZone_Response.BaseUtcOffset !== undefined) {
                var BaseUtcOffset_timezone = Zone_TimeZone_Response.BaseUtcOffset;
                var split_data = BaseUtcOffset_timezone.split(/[\:]/);
                var offset = split_data[0] + '.' + split_data[1];
                var d = new Date();
                var utc = d.getTime() + (d.getTimezoneOffset() * 60000);
                var nd = new Date(utc + (3600000 * offset));
                return nd;
            }
            else {
                return new Date();
            }
        }
    }

    roundDateTime() {
        let { Zone_TimeZone_Response } = this.props
        if (Zone_TimeZone_Response === null) {
            return new Date(Math.ceil(new Date().getTime() / 1800000) * 1800000);
        }
        else {
            if (Zone_TimeZone_Response.BaseUtcOffset !== null || Zone_TimeZone_Response.BaseUtcOffset !== undefined) {
                // var BaseUtcOffset_timezone = Zone_TimeZone_Response.BaseUtcOffset;
                // var BaseUtcOffset_timezone = "05:30:00";
                // var split_data = BaseUtcOffset_timezone.split(/[\:]/);
                //  var offset = split_data[0] + '.' + split_data[1];
                //  var d = new Date();
                // var utc = d.getTime() + (d.getTimezoneOffset() * 60000);
                // var nd = new Date(utc + (3600000 * offset));
                // return new Date(Math.ceil(nd.getTime() / 1800000) * 1800000);
                return new Date(Math.ceil(new Date().getTime() / 1800000) * 1800000);
            }
            else {
                return new Date(Math.ceil(new Date().getTime() / 1800000) * 1800000);
            }
        }
    }

    // refreshEvents() {
    //     this.props.GetAllRequests();
    // }

    onChange(args) {

        this.setState({ Number_of_RecurDays_in_state: args.value })
    }

    onEventRendered(args) { applyCategoryColor(args, this.scheduleObj.currentView); }



    calculateCost() {


        let st, et, tenantID, zoneID = null

        st = this.startTimeObj.changedArgs.value;
        et = this.endTimeObj.changedArgs.value;
        tenantID = this.tenantObj.value;
        zoneID = this.zoneObj.value;


        if (st === null || et === null) {
            document.getElementById('cost_modal_error').innerHTML = 'Error: You left necessary fields blank.';
        }
        else if (st > et) {
            document.getElementById('cost_modal_error').innerHTML = "Error: From date cannot be greater than To date";
        }
        else if (+st == +et) {
            document.getElementById('cost_modal_error').innerHTML = 'Error: From time and To Time cannot be equal!';
        }
        else if (tenantID === null) {
            document.getElementById('cost_modal_error').innerHTML = "Error: Please select tenant from tenants dropdown.";

        }
        else if (zoneID === null) {
            document.getElementById('cost_modal_error').innerHTML = "Error: Please select place from places dropdown.";
        }
        else {
            document.getElementById('cost_modal_error').innerHTML = ""

            var startDateTime = st.getFullYear() + "/" + (st.getMonth() + 1) + "/" + st.getDate() + " " + st.getHours() + ":" + st.getMinutes() + ":00";
            var stopDateTime = et.getFullYear() + "/" + (et.getMonth() + 1) + "/" + et.getDate() + " " + et.getHours() + ":" + et.getMinutes() + ":00";

            let twoDigitMonth = (et.getMonth() + 1).toString().length > 1 ? (et.getMonth() + 1) : "0" + (et.getMonth() + 1).toString();
            let twoDigitDay = et.getDate().toString().length > 1 ? et.getDate() : "0" + et.getDate().toString();


            var recurtime = twoDigitDay + "/" + twoDigitMonth + "/" + et.getFullYear();
            var Request = {
                "StartDateTime": startDateTime,
                "EndDateTime": stopDateTime,
                "ZoneId": JSON.stringify(zoneID),
                "TenantId": JSON.stringify(tenantID),
            }
            if (this.state.RecurDays_in_state) {                                                   // Checking whether repeating option has selected, if yes adding "IsRepeat" ,"RecurDays","RecurTime" key values to request object

                let recuringDays = [];
                let recur_days = ["SU", "MO", "TU", "WE", "TH", "FR", "SA",];
                var days_falling_in_range = false;


                if (this.state.Number_of_RecurDays_in_state !== null) {

                    var Selected_Date_range_for_comparision = [];

                    var currentDate = st;
                    var addDays = function (days) {
                        var date = new Date(this.valueOf());
                        date.setDate(date.getDate() + days);
                        return date;
                    };
                    while (currentDate <= et) {
                        Selected_Date_range_for_comparision.push(currentDate.getDay().toString());
                        currentDate = addDays.call(currentDate, 1);
                    }


                    var arrayContainsArray = function (superset, subset) {
                        return subset.every(function (value) {
                            return (superset.indexOf(value) >= 0);
                        });
                    }


                    var recuring_days_from_calendar = this.state.Number_of_RecurDays_in_state.substring(                    //splitting only recur days string from calendar     Ex : FREQ=WEEKLY;BYDAY=SU,MO,TU,WE,SA;INTERVAL=1; to    ["SU", "MO", "TU", "WE", "SA"]
                        this.state.Number_of_RecurDays_in_state.lastIndexOf("BYDAY=") + 6,
                        this.state.Number_of_RecurDays_in_state.lastIndexOf(";INTERVAL")
                    ).split(",");

                    recur_days.forEach((e1, index) => recuring_days_from_calendar.forEach((e2) => {                // Comparing arrays of static recur_days to dynamically obtained recurring days from calendar to get index values. Ex:   ["SU", "MO", "TU", "WE", "SA"]  to   
                        if (e1 === e2) { recuringDays.push(index.toString()); }                                           //  ["0", "1", "2", "3", "6"]
                    }))

                    days_falling_in_range = arrayContainsArray(Selected_Date_range_for_comparision, recuringDays);

                }


                if (days_falling_in_range) {
                    document.getElementById('cost_modal_error').innerHTML = '';
                    Request["IsRepeat"] = true;
                    Request["RecurDays"] = recuringDays;
                    Request["RecurTime"] = recurtime;
                    //Request["TenantId"] = tenantID;
                }
                else {
                    document.getElementById('cost_modal_error').innerHTML = 'Error: Selected days does not fall in range!';
                    return;
                }

            }
            else {
                Request["isRepeat"] = false;
            }
            this.props.GetCalculateCost(Request);
            this.toggle();
        }


    }

    // Editor template

    editorTemplate(props) {

        return (<div>
            <div ><p className="error_msg error_msg1" id="cost_modal_error"></p></div>

            <table id="custom-event-editor" className="custom-event-editor" style={{ width: '100%', cellpadding: '5' }}><tbody>
                <tr><td className="e-textlabel">Tenant</td><td style={{ colspan: '4' }}>
                    <DropDownListComponent id="tenantName" placeholder='Choose Tenant' className="e-field" style={{ width: '100%' }} dataSource={(this.props.Tenant_List_Response != undefined && this.props.Tenant_List_Response.TenantNameList != undefined) ? this.props.Tenant_List_Response.TenantNameList.filter(el => el.isWorkOrder !== true) : []} fields={this.tenant_dropdown_fields}
                        change={this.LoadTenantZones} ref={(dropdownlist) => { this.tenantObj = dropdownlist; }}  >
                    </DropDownListComponent>
                </td></tr>

                <tr><td className="e-textlabel">Place</td><td style={{ colspan: '4' }}>
                    <DropDownListComponent id="zoneId" placeholder='Choose place' className="e-field" style={{ width: '100%' }} dataSource={this.props.Tenant_ZoneList_Response} fields={this.zones_dropdown_fields}
                        enabled={false} ref={(dropdownlist) => { this.zoneObj = dropdownlist; }}  >
                    </DropDownListComponent>
                </td></tr>
                <tr>
                    <td className="e-textlabel">From</td><td style={{ colspan: '4' }}>
                        {/* <DateTimePickerComponent id="startDateTime" className="e-start e-field"  ref={(st) => { this.startTimeObj = st; }}   min={new Date(Math.ceil(new Date().getTime() / 1800000) * 1800000)}   ></DateTimePickerComponent> */}
                        <DateTimePickerComponent id="startDateTime" className="e-start e-field" ref={(st) => { this.startTimeObj = st; }}     ></DateTimePickerComponent>
                    </td>
                </tr>
                <tr><td className="e-textlabel">To</td><td style={{ colspan: '4' }}>
                    <DateTimePickerComponent id="stopDateTime" className="e-end e-field" ref={(et) => { this.endTimeObj = et; }}    ></DateTimePickerComponent>
                </td></tr>
                <tr><td className="e-textlabel"></td><td style={{ colspan: '4' }}>
                    <div ref={(value) => { this.requestDiv = value }}>
                        <FormGroup check >
                            <Label check>
                                <input type="radio" ref={(value) => { this.reqType = value }} id="reqtype" value="0" name="rdRequestType" defaultChecked="true" onChange={this.handleRadio}/>
                                {' '}
                                Single Request
                                                                    </Label>
                        </FormGroup>
                        <FormGroup check>
                            <Label check>
                                <input type="radio" ref={(value) => { this.reqType = value }} id="repeat_reqtype" name="rdRequestType" value="1" onChange={this.handleRadio}/>
                                {' '}
                                Repeating Request
                                                                    </Label>
                        </FormGroup>
                    </div>
                </td></tr>

                <tr className="repeat_row" ref={t => this.recCompleteObject = t} ><td className="e-textlabel"></td><td style={{ colspan: '4' }}>
                    <RecurrenceEditorComponent id='RecurrenceRule' ref={t => this.recObject = t} frequencies={['weekly']} change={this.onChange.bind(this)}></RecurrenceEditorComponent>
                </td></tr>

                <tr><td className="e-textlabel">Comments</td><td style={{ colspan: '4' }}></td></tr>

                <tr><td colspan='2'>
                    <textarea id="requestComment" ref={(value) => this.commentObj = value} name="requestComment" rows={4} className="default-input" maxLength="500" style={{ width: "100%", resize: "none", marginTop: "5px" }}></textarea>
                </td></tr>

                </tbody></table>

            <FormGroup check row>
                <Button type="button" id="Calculate_cost_btn" className="btn btn-black">Calculate Cost  </Button>
            </FormGroup>


            <div className="custom-footer-content">
                <button type="button" id="request_delete_btn" className="test e-control e-btn e-event-delete e-flat e-disable">Delete</button>
                <button type="button" id="request_cancel_btn" className="test e-control e-btn e-event-cancel e-flat">Cancel</button>
                <button type="button" id="request_save_btn" className="test e-control e-btn e-primary e-event-save e-flat">Save</button>
            </div>

        </div>);

    }
    // End of Editor template
   
    onCreate(filtered_data_update) {           //Displaying starttime & endtime to calendar with same time without timezone
        for (let data of filtered_data_update) {
            let event = data;
            var Startdates = event.startDateTime;

            if (Startdates !== null || Startdates !== undefined) {
                var check_if_not_string = Startdates.indexOf(' ');
                if (check_if_not_string === -1) {
                    event.startDateTime = Startdates.substring(0, 19);
                };
            }

            var Stopdates = event.stopDateTime
            if (Stopdates !== null || Stopdates !== undefined) {
                var check_if_Stp_not_string = Stopdates.indexOf(' ');
                if (check_if_Stp_not_string === -1) {
                    event.stopDateTime = Stopdates.substring(0, 19);
                }
            }
        }
    }

    render(getLabels, Tenant_Request_Cost, UserCanEdit, Zone_TimeZone_Response) {

        let Cost_in_input = null;
        let label = this.props.getLabels;
        // Calculate cost form
        if (this.props.Tenant_Request_Cost.Cost !== undefined && this.props.Tenant_Request_Cost.Cost.data !== undefined) {
            var CostDetail = null;
            CostDetail = this.props.Tenant_Request_Cost.Cost.data;

            var string_check = typeof this.props.Tenant_Request_Cost.Cost.data;

            (string_check === "string") ? CostDetail = JSON.parse(this.props.Tenant_Request_Cost.Cost.data) : CostDetail = this.props.Tenant_Request_Cost.Cost.data;


            if (CostDetail != null) {
                let CurrencySymb = CostDetail.cost.currency, l_Note = '', l_Star = '';
                if (CostDetail.cost.minimumHoursApplied) {
                    l_Note = '*The minimum cost per request has been applied.'
                    l_Star = '*'
                }

                Cost_in_input = <Form style={{ width: '600px' }}>
                    <FormGroup row>
                        <Col sm={8}>
                            <Label className="mdl-DialogHeader">{label['AfterHours.MailBodyRequestCost.Text'] !== undefined ? label['AfterHours.MailBodyRequestCost.Text'] : "Estimated Cost"}</Label>
                        </Col>
                        <Col sm={4} style={{ textAlign: 'right' }}>
                            <Label className="mdl-DialogHeader">{CurrencySymb}{' '}{CostDetail.cost.displayTotalAmount}{l_Star}</Label>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={9}>
                            <Label className="mdl-DialogContent">{label['AfterHours.RequestsCreated.Text'] !== undefined ? label['AfterHours.RequestsCreated.Text'] : "Requests to be created"}</Label>
                        </Col>
                        <Col sm={3} style={{ textAlign: 'right' }}>
                            <Label className="mdl-DialogContent">{CostDetail.cost.noOfRequests}</Label>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={9}>
                            <Label className="mdl-DialogContent">{label['AfterHours.TotalHoursRequested.Text'] !== undefined ? label['AfterHours.TotalHoursRequested.Text'] : "Total hours requested"}</Label>
                        </Col>
                        <Col sm={3} style={{ textAlign: 'right' }}>
                            <Label className="mdl-DialogContent" >{CostDetail.totalHours.toFixed(2)}</Label>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={9}>
                            <Label className="mdl-DialogContent">{label['CreateTenant.AfterHoursHourlyRate.Text'] !== undefined ? label['CreateTenant.AfterHoursHourlyRate.Text'] : "Cost per Hour*"}</Label>
                        </Col>
                        <Col sm={3} style={{ textAlign: 'right' }}>
                            <Label className="mdl-DialogContent">{CurrencySymb}{' '}{CostDetail.cost.amountPerHour}</Label>
                        </Col>
                    </FormGroup>
                    {CostDetail.cost.minimumHoursApplied ? (
                        <FormGroup row>
                            <Col sm={12}>
                                <Label style={{ paddingLeft: '16px' }}>{l_Note}</Label>
                            </Col>
                        </FormGroup>) : ('')
                    }
                    <FormGroup row>
                        <Col sm={9}>
                            {' '}
                        </Col>
                        <Col sm={3} style={{ textAlign: 'right' }}>
                            <input type="button" className="btn btn-link mdl-DialogContent" style={{ color: 'black' }} value="close" onClick={this.toggle} />
                        </Col>
                    </FormGroup>

                </Form>

            }

        }


        return (

            <div className='schedule-control-section'>
                <div className="schdeule_calendar_div">
                    <div className='control-wrapper'>
                        <ScheduleComponent width='100%' height='755px' cssClass='schedule-date-header-template' selectedDate={this.getZoneTimeZoneDate()} showHeaderBar={true} showQuickInfo={false} currentView='Month' ref={t => this.scheduleObj = t} eventSettings={{
                            dataSource: filtered_data_update,
                            fields: { id: 'requestId', subject: { name: 'tenantName' }, location: { name: 'zoneName' }, startTime: { name: 'startDateTime' }, endTime: { name: 'stopDateTime' }, RecurrenceRule: { name: 'RecurrenceRule' }, zoneId: { name: 'zoneId' } },
                            enableTooltip: true,
                            tooltipTemplate: this.template.bind(this),
                        }}
                            editorTemplate={this.editorTemplate}
                            popupOpen={this.onPopupOpen.bind(this)}
                            cellDoubleClick={this.cellDoubleClick.bind(this)}
                            renderCell={this.onRenderCell.bind(this)}
                            allowDragAndDrop={true}
                            eventRendered={this.onEventRendered.bind(this)} actionComplete={this.onActionComplete.bind(this)}
                           // refreshEvents={this.refreshEvents.bind(this)}
                            created={this.onCreate(filtered_data_update)}
                        // timeScale={ { enable: true, interval: 60, slotCount: 2 }}
                        >

                            <Inject services={[Day, Week, WorkWeek, Month, Agenda]} />
                        </ScheduleComponent>
                    </div>
                </div>
                <div className="schdeule_calendar_filter_div">
                    <SearchInput className="search-input schedule_search_input" onChange={this.searchUpdated} />
                    <br />
                    <br />
                    <br />
                    <div>
                        {filter_list}
                    </div>
                </div>

                <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className} style={{ width: '600px', height: '270px' }} >
                    {Cost_in_input}
                </Modal>
            </div>
        );
    }

    searchUpdated(term) {
        this.setState({ searchTerm: term })
    }
}



const mapStateToProps = state => {
    return {
        Tenant_List_Response: state.tenantsRootReducer,
        RequestList_Response: state.RequestRootReducer.AllRequests,
        Zone_TimeZone_Response: state.RequestRootReducer.Zone_TimeZone,
        Tenant_ZoneList_Response: state.ViewtenantsRootReducer.TenantZones,
        Request_Selected_Response: state.RequestRootReducer.SelectedRequest,
        Tenant_Request_Cost: state.tenantsRootReducer,
        getLabels: state.CulturalLabelsRootReducer.LabelsBasedOnPreference,
        UserCanEdit: state.authService.HasApplicationFullAcess,
        PastRequest: state.RequestRootReducer.AllPastRequests
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetAllTenantList: () => dispatch(GetAllTenantList()),
        GetTimeZoneForZone: () => dispatch(GetTimeZoneForZone()),
        GetZonesListforTenant: (tenantID) => dispatch(GetZonesListforTenant(tenantID)),
        DeleteTenantRequests: (data) => dispatch(DeleteTenantRequests(data)),
        GetAllRequests: () => dispatch(GetAllRequests()),
        SaveRequest: (data) => dispatch(SaveRequest(data)),
        UpdateRequest: (data) => dispatch(UpdateRequest(data)),
        GetSelectedRequest: (id) => dispatch(GetSelectedRequest(id)),
        GetCalculateCost: (data) => dispatch(GetCalculateCost(data)),
        GetAllPastRequests: (fromDate,toDate) => dispatch(GetAllPastRequests(fromDate, toDate)),
        GetSelectedPastRequest: (id) => dispatch(GetSelectedPastRequest(id)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestsCalendar);
